// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wildidea {
  --color-grey-0: #f2f2f2;
  --color-grey-1: #f2f2fa;
  --color-grey-2: #d2d2e3;
  --color-grey-3: #888;
  --color-grey-4: #666;
  --color-grey-5: #444;
  --color-grey-6: #222;
  --color-grey-7: #171717;
}

.wildidea {
  --color-paper-1: var(--color-grey-1);
  --color-paper-2: white;
  --color-inverse: black;
  --color-paper-text: black;
  --color-inverse-text: white;
}

@media (prefers-color-scheme: dark) {
  .wildidea:not(.wild-light) {
    --color-paper-1: var(--color-grey-7);
    --color-paper-2: var(--color-grey-7);
    --color-inverse: var(--color-grey-0);
    --color-paper-text: white;
    --color-inverse-text: black;
  }
}
.wild-dark {
  --color-paper-1: var(--color-grey-7);
  --color-paper-2: var(--color-grey-7);
  --color-inverse: var(--color-grey-0);
  --color-paper-text: white;
  --color-inverse-text: black;
}

.wildidea {
  --color-blue-0: #48dbfb;
  --color-blue-1: #0984e3;
  --color-blue-2: #1e3799;
  --color-blue-3: #023047;
  --color-red-0: #ff2962;
  --color-red-1: #d63031;
  --color-red-2: #b71540;
  --color-yellow-1: #fbc531;
  --color-yellow-2: #f6b93b;
  --color-green-1: #27ae60;
  --color-purple-0: #a55eea;
  --color-purple-1: #8e44ad;
  --color-purple-2: #5f27cd;

  --gradient-blue-1: radial-gradient(
    circle at 90% 100%,
    var(--color-blue-1),
    var(--color-blue-0) 250%
  );
  --gradient-purple-1: radial-gradient(
    circle at 90% 100%,
    var(--color-purple-1),
    var(--color-purple-0) 90%
  );
  --gradient-yellow-1: radial-gradient(
    circle at 90% 100%,
    var(--color-yellow-2),
    var(--color-yellow-1) 100%
  );
  --gradient-red-1: radial-gradient(circle at 10% 0%, var(--color-red-2), var(--color-red-1) 100%);
}

.wildidea {
  --shadow-0: 0em 0em 0em rgba(0, 0, 0, 0.15);
  --shadow-1: 0.125em 0.125em 1em rgba(0, 0, 0, 0.15);
  --shadow-2: 0.25em 0.25em 1em rgba(0, 0, 0, 0.15);
  --shadow-3: 0.375em 0.375em 1em 0.125em rgba(0, 0, 0, 0.15);
}

.wildidea {
  --default-transition-duration: 400ms;
  --default-transition-timing: ease;
}

.wildidea {
  --default-focus-outline: var(--color-yellow-1) solid 2px;
}
`, "",{"version":3,"sources":["webpack://./src/theme/variables.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;AACA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;EACD,gGAAgG;AAClG;;AAEA;EACE,2CAA2C;EAC3C,mDAAmD;EACnD,iDAAiD;EACjD,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,wDAAwD;AAC1D","sourcesContent":[".wildidea {\n  --color-grey-0: #f2f2f2;\n  --color-grey-1: #f2f2fa;\n  --color-grey-2: #d2d2e3;\n  --color-grey-3: #888;\n  --color-grey-4: #666;\n  --color-grey-5: #444;\n  --color-grey-6: #222;\n  --color-grey-7: #171717;\n}\n\n.wildidea {\n  --color-paper-1: var(--color-grey-1);\n  --color-paper-2: white;\n  --color-inverse: black;\n  --color-paper-text: black;\n  --color-inverse-text: white;\n}\n\n@media (prefers-color-scheme: dark) {\n  .wildidea:not(.wild-light) {\n    --color-paper-1: var(--color-grey-7);\n    --color-paper-2: var(--color-grey-7);\n    --color-inverse: var(--color-grey-0);\n    --color-paper-text: white;\n    --color-inverse-text: black;\n  }\n}\n.wild-dark {\n  --color-paper-1: var(--color-grey-7);\n  --color-paper-2: var(--color-grey-7);\n  --color-inverse: var(--color-grey-0);\n  --color-paper-text: white;\n  --color-inverse-text: black;\n}\n\n.wildidea {\n  --color-blue-0: #48dbfb;\n  --color-blue-1: #0984e3;\n  --color-blue-2: #1e3799;\n  --color-blue-3: #023047;\n  --color-red-0: #ff2962;\n  --color-red-1: #d63031;\n  --color-red-2: #b71540;\n  --color-yellow-1: #fbc531;\n  --color-yellow-2: #f6b93b;\n  --color-green-1: #27ae60;\n  --color-purple-0: #a55eea;\n  --color-purple-1: #8e44ad;\n  --color-purple-2: #5f27cd;\n\n  --gradient-blue-1: radial-gradient(\n    circle at 90% 100%,\n    var(--color-blue-1),\n    var(--color-blue-0) 250%\n  );\n  --gradient-purple-1: radial-gradient(\n    circle at 90% 100%,\n    var(--color-purple-1),\n    var(--color-purple-0) 90%\n  );\n  --gradient-yellow-1: radial-gradient(\n    circle at 90% 100%,\n    var(--color-yellow-2),\n    var(--color-yellow-1) 100%\n  );\n  --gradient-red-1: radial-gradient(circle at 10% 0%, var(--color-red-2), var(--color-red-1) 100%);\n}\n\n.wildidea {\n  --shadow-0: 0em 0em 0em rgba(0, 0, 0, 0.15);\n  --shadow-1: 0.125em 0.125em 1em rgba(0, 0, 0, 0.15);\n  --shadow-2: 0.25em 0.25em 1em rgba(0, 0, 0, 0.15);\n  --shadow-3: 0.375em 0.375em 1em 0.125em rgba(0, 0, 0, 0.15);\n}\n\n.wildidea {\n  --default-transition-duration: 400ms;\n  --default-transition-timing: ease;\n}\n\n.wildidea {\n  --default-focus-outline: var(--color-yellow-1) solid 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
